export { AlertConfig as AlertConfigPage } from './AlertConfig';
